import type { RoomMemberRole } from './types';

const nonAdminRoles: RoomMemberRole[] = ['engineer', 'artist', 'observer'];

export function canManageRoomAdmin(actorRole?: RoomMemberRole): boolean {
  return actorRole === 'owner' || actorRole === 'system_admin';
}

export function assignableRoomRoles(actorRole?: RoomMemberRole): RoomMemberRole[] {
  return canManageRoomAdmin(actorRole) ? ['admin', ...nonAdminRoles] : [...nonAdminRoles];
}

export function canModifyRoomMember(actorRole: RoomMemberRole | undefined,
                                    targetRole: RoomMemberRole): boolean {
  if (targetRole === 'owner') return false;
  return targetRole !== 'admin' || canManageRoomAdmin(actorRole);
}
